//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchBarForm from '~/components/form/search-bar-form'
import searchUtils from '~/mixins/search/search-utils'
export default {
  name: 'SearchModal',
  components: { SearchBarForm },
  mixins: [searchUtils],
  watch: {
    '$store.state.breakpoint.screen.width' () {
      if (this.$store.state.breakpoint.screen.width >= 768) {
        this.$modal.hide('search-destination-input-modal')
        this.$modal.hide('search-modal')
      }
    }
  }
}
